export default __webpack_public_path__ + "static/media/Animations_Bar11.e67b71b7.svg";